export default "__VITE_ASSET__CYYNxchS__"